import React from 'react';
import { motion } from 'framer-motion';
import './RACWelfare.css';

const RACWelfare = () => {
  console.log('[RACWelfare] Component rendered');
  
  return (
    <section className="rac-welfare">
      <div className="rac-welfare-container">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="rac-welfare-content"
        >
          <h2 className="rac-section-title">Daily Monitoring / Logs & Records</h2>
          <div className="rac-gold-line"></div>
          <div className="rac-welfare-text">
            <ul className="rac-monitoring-list">
              <li>Photos/videos and routine update notes</li>
              <li>Health and treatment notes (as applicable)</li>
              <li>Feeding logs</li>
              <li>Milking notes/data (operational reporting)</li>
              <li>Vet visit records (as applicable)</li>
              <li>Activity notes</li>
            </ul>
            <div className="rac-privacy-note">
              <p><strong>Privacy note:</strong> Daily updates may include staff voices; access is governed by privacy/consent policy. Updates are shared through controlled access (account login/authorized channel); unauthorized redistribution is prohibited. Media and portal logs are retained for 30 days; contractual/transaction records may be retained longer if legally required.</p>
            </div>
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default RACWelfare;


